import { wrapFunction } from './wrapFunction';

export function markFunction<ArgsType extends any[], ReturnType extends any>(
    func: (...args: ArgsType) => ReturnType,
    name: string
): (...args: ArgsType) => ReturnType {
    return wrapFunction(func, () => mark(`${name}_s`), () => markEnd(name));
}

function markEnd(name: string) {
    let endName = `${name}_e`;
    mark(endName);
    if (window.performance && window.performance.measure) {
        window.performance.measure(name, `${name}_s`, endName);
    }
}

let customPltMarkers: { [index: string]: number };
function mark(name: string) {
    if (window.performance && window.performance.mark) {
        window.performance.mark(name);
    } else {
        if (!customPltMarkers) {
            customPltMarkers = {};
        }
        customPltMarkers[name] = Date.now();
    }
}

export function getCustomPltMarkers() {
    return customPltMarkers;
}
